import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MdbRippleModule } from 'src/lib/mdb5-adapted/public-api';
import { LmsModalFrameComponent } from '@lmsSharedUI';
import { BankDetailsModel, ClientShowModel } from '@lmsModels';
import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';

@Component({
  selector: 'app-bank-acc-list',
  templateUrl: './bank-acc-list.component.html',
  styleUrls: ['./bank-acc-list.component.scss'],
  standalone: true,
  imports: [CommonModule, MdbRippleModule, LmsModalFrameComponent],
})
export class BankAccListComponent implements OnInit {
  clientDetails: any;
  bankingDetails: any = {};
  bankDetailsModel: BankDetailsModel = new BankDetailsModel();
  readOnly = false;
  constructor(public dialogRef: MdbModalRef<BankAccListComponent>) {}

  ngOnInit(): void {
    console.log('Banking details laiata...');
  }

  onSelectAccount(accnt: any) {
    console.log(accnt);
    this.bankDetailsModel = accnt;
  }

  submitBankDetails() {
    return this.dialogRef.close(this.bankDetailsModel);
  }

  close() {
    return this.dialogRef.close();
  }
}
